module.exports = __webpack_public_path__ + "media/images/emblems/Valeyres-sous-Montagny-coat_of_arms-7f27b32b607d7175bbcd6b426664f936.svg";